import translations from '../translations';

export const lastLang = {
  current: 'en-GB',
};

export function saveLastPath() {
  localStorage.setItem('lastPath', window.location.pathname);
}

export function loadLastPath() {
  const lastPath = localStorage.getItem('lastPath');
  localStorage.removeItem('lastPath');
  return lastPath;
}

export function saveLocalization(data) {
  localStorage.setItem('localization', JSON.stringify(data));
}

export function loadLocalization() {
  const loc = localStorage.getItem('localization');
  if (loc) return JSON.parse(loc);
  return null;
}

export function saveLang(lang) {
  lastLang.current = lang;
  localStorage.setItem('lang', lang);
}

export function loadLang() {
  let defaultLanguage = navigator?.language;
  // eslint-disable-next-line no-underscore-dangle
  if (!translations._meta.languageCodes.includes(defaultLanguage)) {
    defaultLanguage = 'en-GB';
  }
  const defaultLang = defaultLanguage;
  const lang = localStorage.getItem('lang') || defaultLang;
  lastLang.current = lang;
  return lang;
}
